import {ELicenseStatus} from './definitions';

export default {
  licenses: 'Лицензии и подключенные тарифы',
  termsValidUntil: 'Пользовательское соглашение действительно до:',
  accordingToTerms: 'По условиям договора',
  termsAccepted: 'Пользовательское соглашение принято:',
  licenseStatus: {
    [ELicenseStatus.NEW]: 'Требует внимания',
    [ELicenseStatus.CANCELLED]: 'Отключена',
    [ELicenseStatus.ACTIVE]: 'Активна',
    [ELicenseStatus.ACTIVE_DEBT]: 'Требует внимания',
    [ELicenseStatus.EXPIRED]: 'Просрочена',
    [ELicenseStatus.TEMPORARY_BLOCKED]: 'Временно заблокирована',
  },
  noTariffs: {
    title: 'Давайте подключим тариф',
    subtitle: 'Свяжитесь со своим менеджером, чтобы вам открыли доступные тарифы для этого канала',
    action: 'Написать менеджеру',
  },
  whatsAppMauInfo: '{{count}} из {{tariffCount}}',
  createdAt: 'Создана ',
  cancelledAt: 'Отменена ',
  temporaryblockedAt: 'Временно заблокировано с ',
  validUntil: 'Действительна до ',
  expiredAt: 'Закончилась ',
  validUntilHint: 'Активирована с {{activatedAt}}; оплачена до {{paidUntil}}',
  scheduledCancel: 'Запланировано отключение ',
  showAll: 'Показать все',
  hide: 'Свернуть все',
  button: {
    block: 'Отключить',
    refuse: 'Отказаться',
    cancel: 'Отмена',
  },
  header: {
    name: 'Название лицензии',
    tariff: 'Тариф для лицензии',
    subject: 'Отправитель',
    status: 'Статус',
    whatsAppMau: 'Остаток MAU по тарифу',
    whatsAppAmau: 'Израсходовано AMAU',
    whatsAppAmauHint:
      'AMAU — количество уникальных получателей, взаимодействовавших с вами в текущем месяце сверх лимита тарифа',
    duration: 'Срок действия лицензии',
  },
  licensesInformation: {
    licenses: 'Лицензии:',
    status: {
      [`${ELicenseStatus.ACTIVE}_one`]: '{{count}} активная',
      [`${ELicenseStatus.ACTIVE}_few`]: '{{count}} активные',
      [`${ELicenseStatus.ACTIVE}_many`]: '{{count}} активных',
      [`${ELicenseStatus.EXPIRED}_one`]: '{{count}} просроченная',
      [`${ELicenseStatus.EXPIRED}_few`]: '{{count}} просроченные',
      [`${ELicenseStatus.EXPIRED}_many`]: '{{count}} просроченных',
      [`${ELicenseStatus.CANCELLED}_one`]: '{{count}} отключенная',
      [`${ELicenseStatus.CANCELLED}_few`]: '{{count}} отключенные',
      [`${ELicenseStatus.CANCELLED}_many`]: '{{count}} отключенных',
      [`${ELicenseStatus.TEMPORARY_BLOCKED}_one`]: '{{count}} временно заблокированная',
      [`${ELicenseStatus.TEMPORARY_BLOCKED}_few`]: '{{count}} временно заблокированные',
      [`${ELicenseStatus.TEMPORARY_BLOCKED}_many`]: '{{count}} временно заблокированных',
    },
    needAttention: '{{count}} требует внимания',
  },
  tariffModal: {
    title: 'Тариф {{name}}',
    tariff: 'Тариф:',
    channel: 'Канал: ',
    activeFrom: 'Дата активации:',
    willChange: 'Изменится {{date}}',
  },
  options: {
    edit: 'Изменить дату',
    cancel: 'Не отключать',
  },
  confirmModal: {
    title: 'Вы планируете досрочное отключение лицензии',
    description:
      'Вы выбрали дату отключения <0>{{date}}</0>, она раньше последнего дня действия лицензии. Вы уверены, что хотите отключить лицензию в эту дату?',
  },
  cancelModal: {
    title: 'Запланировать отключение лицензии клиента?',
    description:
      'При отключении лицензия будет заблокирована без возможности восстановления. Оправка и получение сообщений по данному каналу будет недоступна.',
    hint: 'В дату запланированного отключения лицензия блокируется в 23:59:00 МСК',
    selectDate: 'Выберите дату отключения',
    successBlock: 'Отключение лицензии успешно запланировано',
  },
  confirmCancelModal: {
    title: 'Не отключать лицензию?',
    description:
      'Лицензия, отключение которой было запланировано, останется в том же статусе, в котором она есть сейчас.',
    button: 'Не отключать',
    successCancel: 'Отключение лицензии успешно отменено',
  },
  changeModal: {
    title: 'Изменить дату отключения лицензии?',
    description:
      'При отключении лицензия будет заблокирована без возможности восстановления. Оправка и получение сообщений по данному каналу будет недоступна.',
    scheduledDate: 'Запланированная дата отключения',
    newDate: 'Новая дата отключения',
    hint: 'В дату запланированного отключения лицензия блокируется в 23:59:00 МСК',
  },
};
